import {Chip, Grid, IconButton, TextField, Tooltip} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { Close } from "@mui/icons-material";
import { DocumentPrerequisProps } from "./DocumentPrerequis.types";
import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../store";
import { getFichierSollicitation } from "../../../store/expertise/expertise.action";

export default function DocumentPrerequis({ idDocument, libelle, downloadUrl, onFileDeleted, onLibelleModified }: DocumentPrerequisProps) {
	const dispatch = useAppDispatch();
	const [fileLibelle, setFileLibelle] = useState(libelle);

	const onDownloadFile = useCallback(() => {
		if (idDocument) {
			dispatch(getFichierSollicitation(idDocument))
		}
	}, [dispatch, idDocument]);

	const onLibelleDocChange = useCallback(
		(event: any) => {
			console.log(event.target.value);
			setFileLibelle(event.target.value);
			onLibelleModified(event);
		},
		[onLibelleModified]
	);

	return (
		<Chip
			label={
				<Grid container spacing={1} alignItems={"center"}>
					<Grid item>
						<Tooltip title={fileLibelle!} placement="top-start">
						<TextField
							className="fileLibelle"
							variant="standard"
							value={fileLibelle}
							InputProps={{
								disableUnderline: true,
							}}
							onChange={onLibelleDocChange}
						/>
						</Tooltip>
					</Grid>
					<Grid item>
						{downloadUrl && (
							<IconButton size={"small"} onClick={onDownloadFile}>
								<DownloadIcon />
							</IconButton>
						)}

						<IconButton size={"small"} onClick={onFileDeleted}>
							<Close />
						</IconButton>
					</Grid>
				</Grid>
			}
		/>
	);
}
